import toast from 'react-hot-toast';
import { invalidateQueries, useApiMutation, useApiQuery } from './useApiQuery';
import notificationsService, {
  NotificationListParams,
} from '@/services/api/notifications.service';

const notificationsQueryKeys = {
  all: 'notifications',
  list: (params: NotificationListParams) => ['notifications', 'list', params],
  unread: ['notifications', 'unread'],
};

interface UseNotificationsQueryOptions {
  enabled?: boolean;
  refetchInterval?: number;
}

export function useNotifications(
  params: NotificationListParams,
  options: UseNotificationsQueryOptions = {},
) {
  return useApiQuery(
    notificationsQueryKeys.list(params),
    () => notificationsService.list(params),
    {
      enabled: options.enabled,
      refetchInterval: options.refetchInterval,
    },
  );
}

export function useUnreadNotificationsCount(
  options: UseNotificationsQueryOptions = {},
) {
  return useApiQuery(
    notificationsQueryKeys.unread,
    () => notificationsService.getUnreadCount(),
    {
      enabled: options.enabled,
      refetchInterval: options.refetchInterval,
    },
  );
}

export function useMarkNotificationAsRead() {
  return useApiMutation(
    (id: string) => notificationsService.markAsRead(id),
    {
      onSuccess: () => {
        invalidateQueries(notificationsQueryKeys.all);
      },
      onError: (error: unknown) => {
        const message =
          error instanceof Error
            ? error.message
            : 'Não foi possível marcar a notificação como lida.';
        toast.error(message, {
          position: 'bottom-center',
        });
      },
    },
  );
}

export function useMarkAllNotificationsAsRead() {
  return useApiMutation(
    () => notificationsService.markAllAsRead(),
    {
      onSuccess: (result) => {
        invalidateQueries(notificationsQueryKeys.all);
        if (result.updated > 0) {
          toast.success('Notificações marcadas como lidas.');
        }
      },
      onError: (error: unknown) => {
        const message =
          error instanceof Error
            ? error.message
            : 'Não foi possível marcar todas as notificações como lidas.';
        toast.error(message, {
          position: 'bottom-center',
        });
      },
    },
  );
}
